/**
 * Point the browser at this festival's manifest.
 *
 * One deployed app serves every festival, so the manifest cannot be a static
 * file — installing from `ozora.…` must produce an OZORA app, not a generic
 * platform one.
 */
import { useEffect } from 'react';
import { apiUrl } from '@/lib/tenant';

export function useEditionManifest(editionId: string | null, themeColor?: string): void {
  useEffect(() => {
    if (!editionId) return;

    let link = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'manifest';
      document.head.appendChild(link);
    }
    link.href = `${apiUrl()}/editions/${editionId}/manifest.webmanifest`;
    // The manifest lives on another origin, so it needs credentials mode set
    // explicitly or the browser fetches it anonymously and may 404.
    link.crossOrigin = 'use-credentials';

    if (themeColor) {
      let meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'theme-color';
        document.head.appendChild(meta);
      }
      meta.content = themeColor;
    }
  }, [editionId, themeColor]);
}
